import { roomTypesModel } from "./roomTypes";
export const productModel = {
    code: "",
    name: "",
    url: "",
    masterRoomTypes: [],
    roomTypes: roomTypesModel,
    hotelRefCode: ""
};
